import { Component, OnInit } from '@angular/core';
import { LocalStorage } from '@ngx-pwa/local-storage';
import * as $ from 'jquery';
import { SenaceService } from 'src/app/services/senace.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

import * as JSZip from "jszip";
import * as FileSaver from "file-saver";

declare const JSZipUtils: any;
const apiUrl = environment.apiUrl;
const apiDownloadById = environment.apiUrlDownloadById;

@Component({
  selector: 'app-tab-descargar',
  templateUrl: './tab-descargar.component.html',
  styleUrls: ['./tab-descargar.component.css']
})
export class TabDescargarComponent implements OnInit {
  seleccionados = '';
  component = this;
  urlAlfresco = apiDownloadById;  
  siglaExpediente: any;

  constructor(
    private senaceService: SenaceService,
    private localStorage: LocalStorage
  ) { }

  ngOnInit() {
    Swal.fire({
      text: 'Consultando ...',
      icon: 'info',
      showCancelButton: false
    });
    Swal.showLoading();
    this.localStorage.getItem('detalle').subscribe((resp: any[] = []) => {

        const data = resp as any; 

        console.log('tab descarga :' + data);

        if (data && data.correlativo) {
          this.siglaExpediente = data.correlativo.split('-')[1];
          console.log(this.siglaExpediente);
        }

        this.setIniciarDocumentosLista(resp);
        Swal.close();
      }
    )
  }
  
  descargarSeleccionados(anexo, documentos: any): void {
    let docs: any = [];
    if (documentos) {
      documentos.forEach(element => {
        docs.push([`${element}`]);
      });
      anexo = anexo.normalize("NFD").replace(/[\u0300-\u036f]/g, ""); // Remover caracteres
      let data = {
        nombre: anexo,
        path: docs
      }
      Swal.fire({
        text: 'Preparando para la descarga ...',
        icon: 'info',
        showCancelButton: false,
        allowOutsideClick: false
      });
      Swal.showLoading();
      this.senaceService.descargarEnZip(data).subscribe(
        (response) => {
          const blobData = new Blob([response], {
            type: 'application/zip'
          });
          var blob = new Blob([blobData], { type: 'application/zip' });
          var url = window.URL.createObjectURL(blob);
          var anchor = document.createElement("a");
          anchor.download = `${anexo}.zip`;
          anchor.href = url;
          anchor.click();
          Swal.close();
        },
        (error) => {
          Swal.fire({
            title: 'Aviso',
            html: 'Se ha seleccionado una cantidad elevada de archivos, por favor descargue los documentos de manera individual. <span><i class="fa fa-download"></i></span> <br><br> <a href="https://www.youtube.com/watch?v=gIG_YQLHefU" target="_blank"> [VER AQUI TUTORIAL] </a> ',
            icon: 'info',
            confirmButtonText: 'Aceptar'
          })
        }
      );
    }

  }

  setIniciarDocumentosLista(data: any[]) {
    const component = this; // Para hacer referencia a metodos del componente
    let cont = 0;
    var leerDocumento = function (documento, obj, seccion) {
      cont = cont+1;

      let urlDoc = `${component.urlAlfresco}=${obj[documento].docId}`
      $("#tabla-documentos tbody").append(
        $("<tr>")
          .append($("<td>"))
          .append($("<td>").addClass('text-center').append(
            $('<input>')
              .attr('type', 'checkbox')
              .attr('ng-model', 'seleccionados')
              .attr('class', seccion)
              .val(obj[documento].docId)
              .click(function () {
                seleccionarSeccion(false, seccion)
              })
          ))          
          .append($("<td>").addClass('h6 pl-2').text(cont +". " + obj[documento].nombre))
          .append($("<td>").addClass('h6').text(''))
          .append($("<td>").addClass('text-center').append(
            $('<a>').addClass('btn btn-outline-light pl-1 pr-1 pt-0 pb-0 text-dark')
              .attr({
                'href': urlDoc,
                'target': 'blank'
              })
              .append(
                $('<i>').addClass('fa fa-download')
              )
          ))
      );
    }
    var descargarPorSeccion = function (elemento, seccion) {
      if ($('.' + seccion).length > 0) {
        var seleccion = false;
        $('.' + seccion).each(function () {
          if ($(this).prop('checked')) {
            seleccion = true;
          }
        })
        if (!seleccion) {
          Swal.fire({
            title: 'Aviso',
            text: 'Seleccione al menos un documento de la sección',
            icon: 'warning',
            confirmButtonText: 'Aceptar'
          })
        } else {
          var docs = [];
          $('.' + seccion).each(function () {
            if ($(this).prop('checked')) {
              docs.push(...[$(this).val()]);
            }
          });
          var cap = seccion.split(/_(.+)/);
          var txt = $("tr[fila=" + cap[0] + "]").find("td").eq(2).text();
          component.descargarSeleccionados(txt, docs);
        }
      } else {
        Swal.fire({
          title: 'Aviso',
          text: 'No hay documentos en la sección.',
          icon: 'warning',
          confirmButtonText: 'Aceptar'
        })
      }
    }

    var seleccionarSeccion = function (todos, seccion) {
      if (todos) {
        var parent = $('.parent_' + seccion).prop('checked');
        $("input[type=checkbox]").each(function () {
          if ($(this).attr('class') != seccion && $(this).attr('class').indexOf('parent') < 0) {
            $(this).prop('checked', false);
          }
        })
        $("input." + seccion).each(function () {
          $(this).prop('checked', parent);
        });
      } else {
        $("input[type=checkbox]").each(function () {
          if ($(this).attr('class') != seccion) {
            $(this).prop('checked', false);
          }
        })
      }
    }

    const seccionesProyecto = [
      "03. Descripción del proyecto",
      "04. Elaboración de Línea Base",
      "05. Participación Ciudadana",
      "06. Caracterización de impactos ambientales",
      "07. Estrategia de manejo ambiental",
      "08. Valoración económica del Impacto Ambiental",
      "01. Datos Generales del Titular",
      "01. Pagos y otros requisitos TUPA"
    ];
    // let urlAlfresco = $("#tabla-documentos").attr("attrDocumento");
    
    if (data) {
      $.each(data, function (index1, val1) {
        if (index1 === 'solicitud') {
          $.each(val1, function (index2, val2) {
            if (index2 === 'secciones') {
              $.each(val2, function (index3, val3) {
                if (val3.nombre) { // Seccines...
                  $("#tabla-documentos tbody").append(
                    $("<tr>").attr('fila', val3.itemnum)
                      .append($("<td tabindex='0'>"))
                      .append($("<td tabindex='0'>").addClass('text-center').html(val3.itemnum))
                      .append(
                        $("<td>").addClass('h6').attr('colspan', 3).text(val3.nombre)
                      )
                  );
                }
                if (val3.capitulos) { // Capitulos...
                  $.each(val3.capitulos, function (index4, val4) {
                    //if (val4.nombre) { // Capitulos nombre ...
                    if (!seccionesProyecto.includes(val4.nombre) && this.siglaExpediente!='EIAD') {
                      $("#tabla-documentos tbody").append(
                        $("<tr>").attr('fila', `${val3.itemnum}_${val4.itemnum}`)
                          .append(
                            $("<td tabindex='0'>")
                              .addClass('text-center')
                              .append(
                                $('<input>').attr({
                                  'type': 'checkbox',
                                  'class': 'parent_' + val3.itemnum + '_' + val4.itemnum
                                }).click(function () {
                                  seleccionarSeccion(true, val3.itemnum + '_' + val4.itemnum)
                                })
                              )
                          )
                          .append($("<td tabindex='0'>").addClass('text-center').html(`${val3.itemnum}.${val4.itemnum}`))
                          .append($("<td tabindex='0'>").addClass('h6').attr('colspan', 2).text(val4.nombre))
                          .append(
                            $("<td tabindex='0'>").addClass('text-center').append(
                              $('<button>').addClass('btn btn-primary btn-sm pl-1 pr-1 pt-0 pb-0 text-white')
                                .attr({
                                  'type': 'button',
                                })
                                .text('Descargar Capitulo')
                                // .append(
                                //   $('<i>').addClass('fa fa-download ')
                                // )
                                .click(function () {
                                  descargarPorSeccion($(this), val3.itemnum + '_' + val4.itemnum);
                                })
                            )
                          )
                      );

                      if (val4.datos) {
                        $.each(val4.datos, function (index5, val5) {

                          if (val5!= null && val5.documento) leerDocumento('documento', val5, val3.itemnum + '_' + val4.itemnum);
                          if (val5!= null && val5.documentoPDF) leerDocumento('documentoPDF', val5, val3.itemnum + '_' + val4.itemnum);
                          if (val5!= null && val5.documentoFile) leerDocumento('documentoFile', val5, val3.itemnum + '_' + val4.itemnum);
                          if (val5!= null && val5.documentoKMZ) leerDocumento('documentoKMZ', val5, val3.itemnum + '_' + val4.itemnum);

                          // Areas de Intervencion....
                          if (index5 === 'areasIntervencion') {
                            $.each(val5, function (index, val) {
                              if (val.documento) leerDocumento('documento', val, val3.itemnum + '_' + val4.itemnum);                              
                            });
                          }
                          // Documentos....
                          if (index5 === 'documentos') {
                            $.each(val5, function (index, val) {
                              if (val.documento) leerDocumento('documento', val, val3.itemnum + '_' + val4.itemnum);
                              if (val.documentoPdfZip) leerDocumento('documentoPdfZip', val, val3.itemnum + '_' + val4.itemnum);
                              if (val.documentoExcelWord) leerDocumento('documentoExcelWord', val, val3.itemnum + '_' + val4.itemnum);
                            });
                          }
                          // Mapas...
                          if (index5 === 'mapas') {
                            $.each(val5, function (index, val) {
                              if (val.pdfFile) leerDocumento('pdfFile', val, val3.itemnum + '_' + val4.itemnum);
                              if (val.shapeFile) leerDocumento('shapeFile', val, val3.itemnum + '_' + val4.itemnum);
                              if (val.kmzFile) leerDocumento('kmzFile', val, val3.itemnum + '_' + val4.itemnum);
                            });
                          }
                          // areaEfectivaProyecto
                          if (index5 === 'areaEfectivaProyecto') {
                            $.each(val5, function (index, val) {
                              if (val.documento) leerDocumento('documento', val, val3.itemnum + '_' + val4.itemnum);
                            });
                          }
                          // areaEstudio
                          if (index5 === 'areaEstudio') {
                            $.each(val5, function (index, val) {
                              if (val.documento) leerDocumento('documento', val, val3.itemnum + '_' + val4.itemnum);
                            });
                          }
                          // areaInfluencia
                          if (index5 === 'areaInfluencia') {
                            $.each(val5, function (index, val) {
                              if (val.documento) leerDocumento('documento', val, val3.itemnum + '_' + val4.itemnum);
                            });
                          }
                          // autorizaciones
                          if (index5 === 'autorizaciones') {
                            $.each(val5, function (index, val) {
                              if (val.documento) leerDocumento('documento', val, val3.itemnum + '_' + val4.itemnum);
                            });
                          }

                        });
                      }

                    }
                  });
                }
              });
            }
          });
        }

      });
    }
  }

  descargar() {
  }

  


}
